export const title = 'Usuários ativos (Gráfico)';

Quantidade de usuários únicos que abriram o app pelo menos uma vez ao longo do tempo.
